/* eslint-disable react/forbid-prop-types */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react';

import PropTypes from 'prop-types';

import { Button, InputAdornment, TextField } from '@material-ui/core';

import AppConfigRobotType from '~/components/AppConfigRobotType';
import LocaleMessage from '~/components/LocaleMessage';
import Splash from '~/components/Splash/Inside';

const MIN_SECONDS = 15;
const DEFAULT_SECONDS = 15;
const ROBOT_MANAGED_TIMING_TYPES = ['kettybot'];

function normalizeSeconds(value) {
    const parsed = Number(value);
    if (!Number.isFinite(parsed) || parsed < MIN_SECONDS) {
        return MIN_SECONDS;
    }
    return Math.floor(parsed);
}

export default function Timing({
    app,
    updateObject,
    setNeedSaving,
    robotTypes,
    currType,
    setCurrType,
}) {
    const appSettings = app && app.settings ? app.settings : {};
    const [isLoading] = useState(false);
    const [timing, setTiming] = useState(
        appSettings && appSettings.timing ? appSettings.timing : {}
    );

    const r_key = currType.slug ? currType.slug : 'all';
    const r_type_settings = timing[r_key] || {};
    const isRobotManagedTiming = ROBOT_MANAGED_TIMING_TYPES.includes(r_key);

    async function handleSubmit() {
        const data = {
            timing: {
                ...timing,
                [r_key]: {
                    collection_time: normalizeSeconds(
                        r_type_settings.collection_time
                    ),
                    return_time: normalizeSeconds(r_type_settings.return_time),
                },
            },
        };
        updateObject(data);
        setNeedSaving(false);
    }

    function setCurrTypeSettings(key, value) {
        setNeedSaving(true);
        const updated = {
            ...timing,
            [r_key]: {
                ...r_type_settings,
                [key]: value,
            },
        };
        setTiming(updated);
    }

    function handleTimeChange(key, rawValue) {
        if (rawValue === '') {
            setCurrTypeSettings(key, '');
            return;
        }
        setCurrTypeSettings(key, rawValue);
    }

    function handleTimeBlur(key, rawValue) {
        setCurrTypeSettings(key, normalizeSeconds(rawValue));
    }

    function renderSubmitButton() {
        return (
            <div className="col-12 mt-2">
                <Button
                    className="p-3"
                    variant="contained"
                    color="primary"
                    onClick={() => handleSubmit()}
                    fullWidth
                    size="large"
                >
                    <LocaleMessage msg="button.save" />
                </Button>
            </div>
        );
    }

    function renderTimeField(key, labelMsg) {
        const value =
            r_type_settings[key] !== undefined && r_type_settings[key] !== null
                ? r_type_settings[key]
                : DEFAULT_SECONDS;

        return (
            <div className="col-12 mb-5">
                <TextField
                    fullWidth
                    type="number"
                    label={<LocaleMessage msg={labelMsg} />}
                    helperText={
                        <LocaleMessage msg="page.applications.indoor_delivery.timing.min_helper" />
                    }
                    value={value}
                    onChange={event =>
                        handleTimeChange(key, event.target.value)
                    }
                    onBlur={event => handleTimeBlur(key, event.target.value)}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <LocaleMessage msg="label.time.seconds" />
                            </InputAdornment>
                        ),
                        inputProps: {
                            min: MIN_SECONDS,
                            step: 1,
                            style: { textAlign: 'center' },
                        },
                    }}
                />
            </div>
        );
    }

    function renderTimingConfig() {
        if (isRobotManagedTiming) {
            return (
                <div
                    className="col-12 mt-3 mb-5"
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        textAlign: 'center',
                    }}
                >
                    <LocaleMessage msg="page.applications.indoor_delivery.timing.robot_managed" />
                </div>
            );
        }

        return (
            <div
                className="col-12 mt-1 row"
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >
                {renderTimeField(
                    'collection_time',
                    'page.applications.indoor_delivery.timing.collection_time'
                )}
                {renderTimeField(
                    'return_time',
                    'page.applications.indoor_delivery.timing.return_time'
                )}
            </div>
        );
    }

    return (
        <div className="col-12 mb-3 row">
            <div className="sidecard-header">
                <h2>
                    <LocaleMessage msg="label.settings.app.indoor_delivery.timing" />
                </h2>
            </div>

            <div className="sidecard-body">
                {isLoading ? (
                    <Splash />
                ) : (
                    <div
                        className="col-12"
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                    >
                        <AppConfigRobotType
                            className="col-12 mb-5"
                            robotTypes={robotTypes}
                            currType={currType}
                            setCurrType={t => setCurrType(t)}
                        >
                            <div
                                className="col-md-6 col-12 row mb-5"
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                }}
                            >
                                {renderTimingConfig()}
                                {!isRobotManagedTiming
                                    ? renderSubmitButton()
                                    : null}
                            </div>
                        </AppConfigRobotType>
                    </div>
                )}
            </div>
        </div>
    );
}

Timing.propTypes = {
    app: PropTypes.object.isRequired,
    updateObject: PropTypes.func.isRequired,
    setNeedSaving: PropTypes.func.isRequired,
    robotTypes: PropTypes.array.isRequired,
    currType: PropTypes.object.isRequired,
    setCurrType: PropTypes.func.isRequired,
};
